import { ERROR_TYPES } from 'modules/event-manager/event-manager-error';

export const PLATFORM_SELECTION = 'PLATFORM_SELECTION' as const;
export const LOGIN = 'LOGIN' as const;
export const ERROR = 'ERROR' as const;
export const ERROR_SOMETHING_WRONG = ERROR_TYPES.SOMETHING_WRONG;
export const ERROR_NOT_ELIGIBLE = ERROR_TYPES.NOT_ELIGIBLE;
export const ERROR_ALREADY_OPTED = ERROR_TYPES.ALREADY_OPTED;
export const SUCCESS = 'SUCCESS' as const;
export const END_OF_OPERATION = 'END_OF_OPERATION' as const;
